// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"DashBoard_pageHeader__351lJ","dashBoard":"DashBoard_dashBoard__TzJ_X"};